import { useAuth0 } from '@auth0/auth0-react';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { analytics } from '../../utils/analytics';

const HEARTBEAT_INTERVAL_MS = 60_000;

/**
 * Renders nothing; wires the three core product-analytics signals that answer
 * "how many users, how long, which screens":
 *   - session_start — once per authenticated app boot (DAU/MAU, session counts)
 *   - page_view     — on every route change (hot zones; route comes from
 *                     getSafeRoutePattern inside analytics.track)
 *   - heartbeat     — one per visible minute (honest time-in-app; ignores
 *                     abandoned background tabs)
 *
 * PHI-safe by construction: no argument here carries a URL, query, or id —
 * analytics.track stamps only the sanitized route pattern.
 */
export function AnalyticsBoot() {
  const { isAuthenticated } = useAuth0();
  const location = useLocation();

  useEffect(() => {
    if (isAuthenticated) {
      analytics.track('session_start');
    }
  }, [isAuthenticated]);

  useEffect(() => {
    if (isAuthenticated) {
      analytics.track('page_view');
    }
  }, [isAuthenticated, location.pathname]);

  useEffect(() => {
    if (!isAuthenticated) {
      return;
    }

    const id = setInterval(() => {
      if (document.visibilityState === 'visible') {
        analytics.track('heartbeat');
      }
    }, HEARTBEAT_INTERVAL_MS);

    return () => clearInterval(id);
  }, [isAuthenticated]);

  return null;
}
